import { render, staticRenderFns } from "./Vision-general-de-ventas.vue?vue&type=template&id=8c443910"
import script from "./Vision-general-de-ventas.vue?vue&type=script&lang=js"
export * from "./Vision-general-de-ventas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports